import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import Analytics from './assets/js/analytics'
import { directiveTools } from './tools/directive-tool'
window.analytics = new Analytics({  
  agentId: 'companyPer'
})
const app = createApp(App)
directiveTools(app)
app.use(router)
app.mount('#app')
